export const environment = {
  production: true,
  api_url: 'https://ci.fmh.com/fmhciapi',
  fmh_webService: 'https://ws.fmh.com',
  imports: [],
  fmh_mobile_key: 'UEx0a2Z4bW9ydVRqUDByMzJzRWE='
};
